import { ContentBlockIntroCopyCentered } from '@dfh-corp-sites/ui'
import React, { useEffect } from 'react'

import { SanityContentBlockIntroCopyCentered as SanityContentBlockIntroCopyCenteredProps } from '../../../graphql/gatsby'
import { setAnalyticsEvent } from '../../../lib/analytics/state'
import { useSanityRoleBasedContent } from '../../../lib/sanity'

const SanityContentBlockIntroCopyCentered = ({
  content,
  roleBasedContent,
}: SanityContentBlockIntroCopyCenteredProps) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })
  useEffect(() => {
    setAnalyticsEvent({
      _key: `sanitycontentblock-introcopycentered`,
      event: 'select_content',
      content_type: 'content block',
      item_id: `sanitycontentblock-introcopycentered`,
      title: content || '',
      label_text: content || '',
      link_destination: '',
      module_name: 'SanityContentBlock',
      module_variant: 'SanityContentBlockIntroCopyCentered',
    })
  }, [content])

  return shouldDisplay ? <ContentBlockIntroCopyCentered content={content || ''} /> : null
}
export default SanityContentBlockIntroCopyCentered
